<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="busRegisters"
      class="elevation-1"
      :items-per-page="5"
      :server-items-length="totalCount"
      :loading="loading"
      :page="page"
      no-data-text="Không có dữ liệu"
      disableSort
      @update:options="paginationChange"
    >
      <template v-slot:[`item.student`]="{ item }">
        <CardStudentName :student="item.student" link />
      </template>
      <template v-slot:[`item.class`]="{ item }">
        <router-link style="text-decoration: none" :to="'/class/' + get(item, 'class.id')">
          <div>{{ get(item, 'class.title', '') }}</div>
        </router-link>
      </template>
      <template v-slot:[`item.bus`]="{ item }">
        <router-link style="text-decoration: none" :to="'/bus/' + get(item, 'bus.id')">
          <div>{{ get(item, 'bus.name') }}</div>
        </router-link>
      </template>
      <template v-slot:[`item.bus_schedule`]="{ item }">
        <div>{{ item.busSchedule | getBusTimeline }}</div>
      </template>
      <template v-slot:[`item.driver`]="{ item }">
        <router-link style="text-decoration: none" :to="'/teacher/' + get(item, 'bus.driver.id')">
          <div>{{ get(item, 'bus.driver.name') }}</div>
        </router-link>
        <div>{{ get(item, 'bus.driver.phone') }}</div>
      </template>
      <template v-slot:[`item.headTeacher`]="{ item }">
        <router-link style="text-decoration: none" :to="'/teacher/' + get(item, 'headTeacher.id')">
          <div>{{ get(item, 'headTeacher.name') }}</div>
        </router-link>
        <div>{{ get(item, 'headTeacher.phone') }}</div>
      </template>
      <template v-slot:[`item.register`]="{ item }">
        <div class="d-flex align-center">
          <v-chip class="ml-3" small label :color="item.register | getRegisterBusColor" dark>
            <span class="mr-1">
              {{ item.register | getRegisterBusText }}
            </span>
          </v-chip>
        </div>
      </template>
      <template v-slot:[`item.attendance`]="{ item }">
        <div class="d-flex align-center">
          <v-chip class="ml-3" small label :color="item.attendance | getAttendanceBusColor" dark>
            <span class="mr-1">
              {{ item.attendance | getAttendanceBusText }}
            </span>
          </v-chip>
        </div>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <div class="d-flex align-center">
          <v-chip class="ml-3" small label :color="item.status | getAttendanceStatusColor" dark>
            <span class="mr-1">
              {{ item.status | getBusStudentAttendanceStatus }}
            </span>
            <span>{{ getTimeStatus(item) }} </span>
          </v-chip>
        </div>
      </template>
    </v-data-table>
    <table class="freeze-table">
      <thead>
        <tr class="header-table">
          <th>Thao tác</th>
        </tr>
      </thead>
      <tbody>
        <tr class="content-action border-b" v-for="item in busRegisters" :key="item.id">
          <td>
            <div class="d-flex align-center justify-center">
              <BusStudentAttendanceListActions
                v-if="item.studentTrackingId"
                :studentTrackingId="item.studentTrackingId"
              />
              <v-menu offset-y>
                <template v-slot:activator="{ attrs }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn @click="registerBus(item)" v-bind="attrs" v-on="on" icon>
                        <v-icon>mdi-update</v-icon>
                      </v-btn>
                    </template>
                    <span>Đi / Không đi</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn @click="attendanceBus(item)" v-bind="attrs" v-on="on" icon>
                        <v-icon>mdi-check-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>Điểm danh</span>
                  </v-tooltip>
                </template>
              </v-menu>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="freeze-table-left">
      <thead>
        <tr class="header-table">
          <th><span class="ml-3">Học sinh</span></th>
        </tr>
      </thead>
      <tbody>
        <tr class="content-action border-b" v-for="item in busRegisters" :key="item.id">
          <td><CardStudentName class="ml-3" :student="item.student" link /></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import BusStudentAttendanceListActions from '@/modules/bus/BusStudentAttendanceListActions.vue'
import { getHeaders } from './BusRegisterTodayTable/helper'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { get } from 'lodash'
export default {
  components: {
    CardStudentName,
    BusStudentAttendanceListActions
  },
  data() {
    return {
      get,
      pagination: {}
    }
  },

  computed: {
    ...mapState({
      busRegisters: state => state.busRegister.busRegisters,
      totalCount: state => state.busRegister.totalCount,
      query: state => state.busRegister.query,
      loading: state => state.busRegister.loading
    }),
    ...mapGetters('auth', ['ownClassIds', 'role']),
    headers() {
      return getHeaders({ role: this.role, ownClassIds: this.ownClassIds })
    }
  },
  methods: {
    ...mapActions({
      fetch: 'busRegister/fetch',
      count: 'busRegister/count',
      update: 'busRegister/update'
    }),
    ...mapMutations({
      setState: 'busRegister/setState'
    }),
    async paginationChange(pagination) {
      try {
        if (!pagination) pagination = this.pagination
        this.setState({ attribute: 'loading', data: true })
        const start = (pagination.page - 1) * pagination.itemsPerPage
        const limit = pagination.itemsPerPage
        this.pagination = pagination
        await this.fetch({ ...this.query, _start: start, _limit: limit })
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.setState({ attribute: 'loading', data: false })
      }
    },
    attendanceBus(item) {
      this.$dialog.confirm({
        title: 'Sửa trạng thái đăng kí',
        text: `Xác nhận sửa trạng thái điểm danh từ <span style="color:${this.getColorConfirm(
          item.attendance
        )}">${this.getTextConfirm(
          'attendance',
          item.attendance
        )}</span> thành <span style="color:${this.getColorConfirm(!item.attendance)}">${this.getTextConfirm(
          'attendance',
          !item.attendance
        )}</span>`,
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.update({ id: item.id, attendance: !item.attendance })
            this.$alert.success('Chỉnh sửa thành công')
            this.paginationChange(this.pagination)
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    },
    registerBus(item) {
      this.$dialog.confirm({
        title: 'Sửa trạng thái điểm danh',
        text: `Xác nhận sửa trạng thái điểm danh từ <span style="color:${this.getColorConfirm(
          item.register
        )}">${this.getTextConfirm('register', item.register)}</span> thành <span style="color:${this.getColorConfirm(
          !item.register
        )}">${this.getTextConfirm('register', !item.register)}</span>`,
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.update({ id: item.id, register: !item.register })
            this.$alert.success('Chỉnh sửa thành công')
            this.paginationChange(this.pagination)
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    },
    getTextConfirm(type, value) {
      if (type === 'register') return value === true ? 'Có đi' : 'Không đi'
      if (type === 'attendance') return value === true ? 'Đã lên xe' : 'Chưa lên xe'
      return ''
    },
    getColorConfirm(value) {
      return value === true ? 'green' : 'red'
    },
    getTimeStatus(item) {
      if (item.status === 'attendance') {
        return item.timeCheckIn ? ' - ' + moment(Number.parseInt(item.timeCheckIn)).format('LT') : ''
      } else if (item.status === 'left') {
        return item.timeCheckOut ? ' - ' + moment(Number.parseInt(item.timeCheckOut)).format('LT') : ''
      } else return ''
    }
  }
}
</script>

<style lang="scss">
.relative {
  position: relative;
}
.freeze-table {
  position: absolute;
  top: 0;
  right: 0;
  width: 130px;
  background-color: white;
  border-collapse: collapse;
}
.freeze-table-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 300px;
  background-color: white;
  border-collapse: collapse;
  text-align: left;
}
.header-table {
  height: 47px;
  font-size: 13px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.6);
  background-color: rgba(0, 0, 0, 0.05);
}
.content-action {
  height: 72px;
}
.border-b {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
